<template>
  <slot v-bind="{ activator, href }"/>
</template>

<script setup>
import route from "ziggy-js"
import { computed } from "vue"
import { map, toPairs } from "lodash-es"
import { params } from "@/support"

const props = defineProps({
  autoplay: Boolean,
  episode: Object,
  playlist: Object,
  forcePopout: Boolean,
  syncTime: Boolean,
  theme: String,
})

const width = 640
const height = 280

const features = {
  location: false,
  menubar: false,
  resizable: true,
  scrollbars: false,
  status: false,
  width,
  height,
  top: parseInt((screen.availHeight - height) / 2),
  left: parseInt((screen.availWidth - width) / 2),
}

const href = computed(() => props.episode?.url)

const activator = () => {
  const plyr = window.plyr

  const admin = window.user?.is_admin
  const prefersTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : null

  const autoplay = (props.autoplay || plyr?.playing) ? "on" : null
  const theme = props.theme ?? (admin && !plyr && (localStorage.theme ?? prefersTheme))
  const time = props.syncTime && plyr?.currentTime ? parseInt(plyr.currentTime) : null

  const playerUrl = props.playlist?.slug
    ? route("podcasts.iatl.playlists.player", [props.playlist.slug, props.episode?.id, props.episode?.slug])
    : (props.episode?.player_url ?? route("podcasts.iatl.player"))

  const url = params(playerUrl, { autoplay, theme, time })

  for (const context of [window, ...map(document.querySelectorAll("iframe[src*=player]"), "contentWindow")]) {
    context.plyr?.pause()
  }

  if (window.location.href.includes("/player") && !props.forcePopout) {
    window.location = url

    return
  }

  window.open(url, "player", map(toPairs(features), item => item.join("=")).join(","))
}
</script>
